﻿export class Country
{
    englishShortName:string="";
    alpha2Code:string="";
    alpha3Code:string="";
    numeric:number|null = null;
    diallingCode:string="";
    currencyName:string="";
    currencyCode:string="";
}